<!--
 * @Author: 汪俊洪
 * @Date: 2025-06-04 19:32:09
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-09 15:33:22
 * @Description:
-->
<template>
  <div class="wrap">
    <h2 class="title">加入中控技术<span>工程生态资源库</span></h2>
    <div class="content">
      <div class="left">
        <el-form
          :model="dataForm"
          :rules="rules"
          ref="dataForm"
          label-width="0"
        >
          <el-form-item label="" prop="name">
            <el-input
              placeholder="姓名"
              v-model="dataForm.name"
              clearable
              maxlength="100"
              :disabled="!!dataForm.name && !!notEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="mobile">
            <el-input
              placeholder="手机号"
              v-model="dataForm.mobile"
              clearable
              maxlength="100"
              :disabled="!!dataForm.mobile && notEdit === 2"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="smsCode">
            <el-input
              placeholder="验证码"
              v-model="dataForm.smsCode"
              clearable
              maxlength="6"
            ></el-input>
            <el-button
              @click="sendcode"
              :loading="loading"
              class="verifyBtn"
              type="text"
              :disabled="disabled"
              >{{ btntxt }}</el-button
            >
          </el-form-item>
          <el-form-item label="" prop="companyName">
            <el-select
              class="full"
              v-model="dataForm.companyName"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="请输入企业名称"
              @change="onCompanyChange"
              :remote-method="companyRemoteMethod"
              :loading="companyLoading"
              allow-create
            >
              <el-option
                v-for="i in companyOptions"
                :key="i.value"
                :label="i.label"
                :value="i.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="industry">
            <el-select
              v-model="dataForm.industry"
              clearable
              placeholder="请选择行业"
              class="full"
            >
              <el-option
                v-for="item in industryOptions"
                :key="item.code"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="abilityId">
            <el-cascader
              v-model="dataForm.abilityId"
              :options="options"
              clearable
              class="full"
              placeholder="请选择能力"
              :props="{
                emitPath: false,
                label: 'abilityName',
                value: 'id',
                children: 'children'
              }"
            ></el-cascader>
          </el-form-item>
          <el-form-item
            label="证明材料："
            label-width="94px"
            prop="attachmentIds"
          >
            <Upload
              size="small"
              :key="row.applyId"
              :list="dataForm.attachmentIds"
              @success="success"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="full submit-btn"
              :disabled="!agreeChecked"
              @click="submitForm('dataForm')"
              >立即申请</el-button
            >
          </el-form-item>
          <el-form-item>
            <div class="tip">申请通过后同步注册宁东工业超市平台会员</div>
            <div class="submitTip">
              <el-checkbox v-model="agreeChecked"></el-checkbox>
              阅读并同意以下协议<a @click.stop="visible = true">{{
                $t('login.servicePolicy')
              }}</a
              ><a @click.stop="visiblePrivacy = true">{{
                $t('login.userPrivacyPolicy')
              }}</a>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="right">
        <div class="item">
          <h3 class="item-title">·全流程在线化管理</h3>
          <div class="item-des">
            从生态伙伴入驻、能力认证到任务派单、报工结算等全链条数字化操作，提升效率与透明度
          </div>
        </div>
        <div class="item">
          <h3 class="item-title">·精准化资源匹配</h3>
          <div class="item-des">
            甚于行业、能力智能推荐，快速精准匹配伙伴与项目机会
          </div>
        </div>
        <div class="item">
          <h3 class="item-title">·生态化协同发展</h3>
          <div class="item-des">
            提供行业与技术赋能，助力生态伙伴提升竞争力，共同拓展市场
          </div>
        </div>
      </div>
    </div>
    <UserAgree v-if="visible" :visible="visible" @close="visible = false" />
    <PrivacyAgree
      v-if="visiblePrivacy"
      :visible="visiblePrivacy"
      @close="visiblePrivacy = false"
    />
  </div>
</template>

<script>
import { phoneReg } from '@/utils/reg'
import { isMobile } from '@/utils/validate'
import { getUUID } from '@/utils'
import { getAccessToken } from '@/utils/userInfo'
import UserAgree from '@/views/pages/components/userAgree'
import PrivacyAgree from '@/views/pages//components/privacyAgree'
import Upload from './upload'

export default {
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    UserAgree,
    PrivacyAgree,
    Upload
  },
  data () {
    return {
      visible: false,
      visiblePrivacy: false,
      agreeChecked: false,
      industryOptions: [
        ...(window.SITE_CONFIG.dictList.OMS_OSS_APPLY_INDUSTRY || '')
      ],
      options: [],
      dataForm: {
        name: '', // 姓名(长度限制20)
        mobile: '', // 手机号
        smsCode: '', // 验证码
        requestId: '', // 验证码对应的请求ID(测试环境传12345690不校验短信验证码)
        companyName: '', // 企业名称（长度限制100）
        socialCreditCode: '', // 企业社会信用代码（长度限制32）
        industry: '', // 行业（长度限制50）
        abilityId: '', // 能力（末级ID）
        attachmentIds: [] // 证明材料（aliOssId列表，最多5个）
      },
      rules: {
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        mobile: [
          {
            required: true,
            message: '请输入手机号',
            trigger: ['blur', 'change']
          },
          {
            pattern: phoneReg,
            message: '请输入正确的手机号码',
            trigger: ['blur', 'change']
          }
        ],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'change' }
        ],
        industry: [
          { required: true, message: '请选择行业', trigger: 'change' }
        ],
        abilityId: [
          { required: true, message: '请选择能力', trigger: 'change' }
        ],
        attachmentIds: [
          {
            required: true,
            type: 'array',
            message: '请上传证明材料',
            trigger: 'change'
          }
        ]
      },
      disabled: false,
      loading: false,
      time: 0,
      btntxt: this.$t('login.captchaGet'),
      companyOptions: [],
      companyLoading: false,
      notEdit: 0 // 默认是0 1为不能编辑姓名 2为不能编辑姓名和手机号
    }
  },
  created () {
    this.getTree()
    this.getCaptcha()
    this.setDefault()
  },
  methods: {
    setDefault () {
      // 如果是申请
      if (this.row.applyId) {
        const industry =
        this.industryOptions.find((v) => v.value === this.row.industry) || {}
        this.dataForm = {
          name: this.row.name, // 姓名(长度限制20)
          mobile: this.row.mobile, // 手机号
          smsCode: '', // 验证码
          requestId: '', // 验证码对应的请求ID(测试环境传12345690不校验短信验证码)
          companyName: this.row.companyName, // 企业名称（长度限制100）
          socialCreditCode: this.row.socialCreditCode, // 企业社会信用代码（长度限制32）
          industry: industry.value, // 行业（长度限制50）
          abilityId: this.row.abilityId, // 能力（末级ID）
          attachmentIds: this.row.proofFiles // 证明材料（aliOssId列表，最多5个）
        }
      } else if (getAccessToken()) {
        // 如果已经登录了 填充部分字段
        const user = this.$store.state.user
        this.dataForm = {
          name: user.name, // 姓名(长度限制20)
          mobile: user.mobile, // 手机号
          smsCode: '', // 验证码
          requestId: '', // 验证码对应的请求ID(测试环境传12345690不校验短信验证码)
          companyName: user.defaultCompanyName, // 企业名称（长度限制100）
          socialCreditCode: '', // 企业社会信用代码（长度限制32）
          industry: '', // 行业（长度限制50）
          abilityId: '', // 能力（末级ID）
          attachmentIds: [] // 证明材料（aliOssId列表，最多5个）
        }
      }
      if (this.dataForm.name) {
        this.notEdit = 1
      }
      if (isMobile(this.dataForm.mobile)) {
        this.notEdit = 2
      }
    },
    success (arr) {
      const newArr = []
      arr.forEach((v) => {
        if (v.response) {
          newArr.push(v.response.data.aliOssId)
        }
      })
      this.dataForm.attachmentIds = newArr
      setTimeout(() => {
        this.$refs.dataForm.validateField('attachmentIds')
      }, 100)
    },
    // 获取验证码
    getCaptcha () {
      this.dataForm.uuid = getUUID()
      this.captchaPath = `${window.SITE_CONFIG['apiURL']}/front/consumer/sysCaptcha/${this.dataForm.uuid}`
    },
    // 手机验证发送验证码
    sendcode () {
      // const reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/
      if (this.dataForm.mobile === '') {
        this.$message({
          message: '手机号不能为空',
          type: 'warning'
        })
        return
      }
      if (!isMobile(this.dataForm.mobile)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        })
        return false
      } else {
        this.loading = true
        this.dataForm.requestId = ''
        this.disabled = true
        // 快捷登录发送验证码
        this.$http
          .get(
            `/front/consumer/sendVerificationCode?mobile=${this.dataForm.mobile}`
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.dataForm.requestId = res.data.requestId
              this.time = 60
              this.timer()
            } else {
              this.getCaptcha()
              this.disabled = false
            }
          })
          .catch(() => {
            this.disabled = false
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    // 60S倒计时
    timer () {
      if (this.time > 0) {
        this.time--
        this.disabled = true
        this.btntxt = this.time + 's' + this.$t('login.captchaGetAgain')
        this.$nextTick(() => {
          setTimeout(this.timer, 1000)
        })
      } else {
        this.time = 0
        this.btntxt = this.$t('login.captchaGet')
        this.disabled = false
        this.getCaptcha()
      }
    },
    // 获取类目树
    getTree () {
      this.$http.get('/front/oms/abilityDict/tree').then(({ data: res }) => {
        if (res.code === 0) {
          this.options = res.data || []
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.doSubmit()
        }
      })
    },
    doSubmit () {
      const obj = {
        ...this.dataForm
      }
      this.$http
        .post('/front/oms/sso/supplier/addApply', obj)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return
          }
          const code = res.data.code
          if ([910003].includes(code)) {
            this.$alert(res.data.message, '提示', {
              confirmButtonText: '确定',
              customClass: 'pre-line',
              callback: () => {
                window.location.reload()
              }
            })
            return
          }
          if ([910004].includes(code)) {
            this.$confirm(res.data.message, '提示', {
              confirmButtonText: '去登录',
              cancelButtonText: '取消',
              customClass: 'pre-line',
              type: 'warning'
            }).then(() => {
              if (getAccessToken()) {
                window.location.href = '/ecologicalServices'
                return
              }
              sessionStorage.setItem('redirectUrl', '/ecologicalServices')
              this.$emit('cancel')
              this.bus.$emit('showLoginDialog')
            })
            return
          }
          this.$alert('提交成功', '提示', {
            confirmButtonText: '确定',
            callback: () => {
              window.location.reload()
            }
          })
        })
    },
    onCompanyChange (res) {
      if (!res) {
        this.dataForm.socialCreditCode = ''
        return
      }
      const val = (this.companyOptions || []).find((i) => i.companyName === res)

      if (val) {
        this.dataForm.socialCreditCode = val.socialCreditCode
      } else {
        this.dataForm.socialCreditCode = ''
      }
    },
    companyRemoteMethod (str) {
      if (!str) return
      this.companyLoading = true
      this.$http
        .get(
          `/inter/qixinbao/fuzzyQueryByKeyword?keyword=${str}&matchType=ename&region=&skip=`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.companyOptions = res.data.map((item) => {
              return {
                ...item,
                label: item.companyName,
                value: item.companyName
              }
            })
          }
        })
        .finally(() => {
          this.companyLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  .title {
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    color: #3d3d3d;
    text-align: center;
    margin: 0;
    span {
      color: #482ec7;
    }
  }
  .content {
    display: flex;
    padding-top: 20px;
    .left {
      flex: 1;
      padding-right: 60px;
      overflow: hidden;
    }
    .right {
      width: 260px;
      height: 469px;
      background: url(~@/assets/img/ecology/join_bg.png) no-repeat center;
      padding: 0 20px;
      .item {
        padding-top: 40px;
      }
      .item-title {
        font-size: 20px;
        font-weight: 500;
        color: #2a54d1;
        margin: 0;
      }
      .item-des {
        padding-top: 4px;
        font-size: 14px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.4);
      }
    }
  }
}
.full {
  width: 100%;
}
.submit-btn {
  border-radius: 4px;
  background: #2a54d1;
  &:hover {
    opacity: 0.8;
  }
  &.is-disabled {
    background: #74b7ff;
    opacity: 0.3;
  }
}
.submitTip {
  font-family: AlibabaPuHuiTi;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #666666;
  margin-top: 20px;
  ::v-deep .el-checkbox__label {
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #666666;
  }
  a {
    color: #2a54d1;
    cursor: pointer;
  }
}
.tip {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.2);
  text-align: center;
  line-height: 16px;
}

.verifyBtn {
  position: absolute;
  top: 0;
  right: 10px;
  font-size: 14px;
  color: #2a54d1;
}
</style>
